import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Button, Typography} from 'views/components';

import {Translate} from 'views/module';

const Header = (props) => {
  return (
    <Grid container>
      <Grid item md={9} xs={6} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography
          variant={'h5'}
          sx={{fontFamily: 'Mono', fontSize: '2rem'}}
          align='left'
        >
          <Translate expression='clientLead.ClientLeadList.Title' />
        </Typography>
        <Button
          sx={{ml: 2}}
          href='/client'
        >
          <Translate expression='clientLead.ClientLeadList.ClientPage' />
        </Button>
      </Grid>
      <Grid item md={3} xs={6} sx={{display: 'flex', margin: 'auto', justifyContent: 'flex-end'}}>
        <Button
          href='/client/new'
        >
          <Translate expression='clientLead.ClientLeadList.Action' />
        </Button>
      </Grid>
    </Grid>
  );
};
Header.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Header));
